export const state = () => {
  return {
    mainCity: null,

    minimumAge: null,
    adultAge: null,

    baseUrl: null,
    languageDefaultCode: null,
    languages: [],

    toggle: {},

    openedPageInModal: '',

    emailRegexp: '',
  }
}
